import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";

import apiCall from "../../../components/Api";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/Breadcrumbs";
import InputRadioField from "../../../components/Common/inputRadioField";
import InputTextField from "../../../components/Common/inputTextField";
import SucessModal from "../../../components/Modal/SucessModal";

const AddSitemapCategoryForm = ({ edit = false }) => {
  const { id } = useParams();
  const {
    register,
    setValue,
    watch,
    formState: { errors },
    handleSubmit,
    trigger,
  } = useForm();

  const [success, setSuccess] = useState(false);

  useEffect(() => {
    edit && getMenuData();
  }, [edit]);

  const getMenuData = async () => {
    try {
      const response = await apiCall(`sitemap-category/get/${id}`, "GET");
      if (response) {
        setValue("active", response.data.active);
        setValue("title", response.data.title);
        trigger();
      }
    } catch (err) {
      console.log(false);
    }
  };

  const onSubmit = (fields) => {
    if (edit) {
      axios
        .patch(
          `${process.env.REACT_APP_API_URL}sitemap-category/update/${id}`,
          fields,
        )
        .then((response) => {
          if (response.data?._id) {
            setSuccess(true);
          } else {
            alert("Fail");
            console.log("failed...");
          }
        });
    } else {
      axios
        .post(`${process.env.REACT_APP_API_URL}sitemap-category/create`, fields)
        .then((response) => {
          if (response.data?._id) {
            setSuccess(true);
          } else {
            alert("Fail");
            console.log("failed...");
          }
        });
    }
  };
  const breadcrumbsList = useMemo(
    () => [
      { text: "Sitemap", link: "/add-sitemap-form/parent-sitemap" },

      { text: "Common Masters", link: "/sitemap-category" },
    ],
    [],
  );

  return (
    <>
      <Breadcrumbs
        className="healthsyMasterBreadCrumbs"
        breadcrumbsList={breadcrumbsList}
      />
      {/* <BackBtn
                navigatePath="/category"
            /> */}
      <div className="healtharticle">
        <div className="pt-1">
          {/* <Breadcrumbs
                        breadcrumbText="Sitemap"
                        breadcrumbLink="/category"
                        nestedText="Common Masters"
                        nestedLink="#"
                    /> */}
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="carr-dep-form">
          <div className="row car-dep-form">
            <div className="col-5">
              <InputTextField
                register={register}
                errors={errors}
                labelName={`${edit ? "Edit" : "Add"} Sitemap Category`}
                errorText="Please enter the Sitemap Category"
                name="title"
                placeholder="Type here..."
              />
            </div>

            <div className="col-3">
              <InputRadioField
                register={register}
                errors={errors}
                setValue={setValue}
                watch={watch}
                labelName="Status"
              />
            </div>
          </div>

          <div className="car-dep-form-button">
            <button type="submit">Submit</button>
          </div>
        </form>
      </div>
      {/* </Home> */}
      {success && (
        <SucessModal
          page={"/sitemap-category"}
          name="new sitemap category"
          post={edit ? "updated" : "added"}
        />
      )}
    </>
  );
};

export default AddSitemapCategoryForm;
